import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const LinksContainer = styled.div`
  a img {
    height: 52px;
    margin-right: 15px;
  }
`;
